import Listing from './Listing';
export default Listing;
export { default as getData } from './getData';